/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs */

const en_subscription_exclusive_feature_encourage_phrase_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encourage yourself with words you love`)
};

const ar_subscription_exclusive_feature_encourage_phrase_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شجع نفسك بالكلمات التي تحبها`)
};

const de_subscription_exclusive_feature_encourage_phrase_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ermutigen Sie sich selbst mit Worten, die Sie lieben`)
};

const es_subscription_exclusive_feature_encourage_phrase_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motívate usando palabras que te gusten`)
};

const fr_subscription_exclusive_feature_encourage_phrase_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivez-vous avec des mots que vous aimez`)
};

const it_subscription_exclusive_feature_encourage_phrase_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incoraggiati con le parole che ami`)
};

const ja_subscription_exclusive_feature_encourage_phrase_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`好きな言葉でモチベーションアップ`)
};

const ko_subscription_exclusive_feature_encourage_phrase_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`좋아하는 말로 자신을 격려하세요`)
};

const pt_br_subscription_exclusive_feature_encourage_phrase_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incentive-se com palavras que você ama`)
};

const ru_subscription_exclusive_feature_encourage_phrase_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подбадривайте себя любимыми словами`)
};

const th_subscription_exclusive_feature_encourage_phrase_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ให้กำลังใจตัวเองด้วยคำพูดที่คุณรัก`)
};

const tr_subscription_exclusive_feature_encourage_phrase_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sevdiğin kelimelerle kendini cesaretlendir`)
};

const zh_cn_subscription_exclusive_feature_encourage_phrase_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用喜欢的话鼓励自己`)
};

const zh_tw_subscription_exclusive_feature_encourage_phrase_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用喜歡的話鼓勵自己`)
};

/**
* | output |
* | --- |
* | "Encourage yourself with words you love" |
*
* @param {Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_encourage_phrase_subtitle = /** @type {((inputs?: Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Encourage_Phrase_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_encourage_phrase_subtitle(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_encourage_phrase_subtitle(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_encourage_phrase_subtitle(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_encourage_phrase_subtitle(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_encourage_phrase_subtitle(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_encourage_phrase_subtitle(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_encourage_phrase_subtitle(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_encourage_phrase_subtitle(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_encourage_phrase_subtitle(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_encourage_phrase_subtitle(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_encourage_phrase_subtitle(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_encourage_phrase_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_encourage_phrase_subtitle(inputs)
	return zh_tw_subscription_exclusive_feature_encourage_phrase_subtitle(inputs)
});